import { ItemType } from "../types";

export const isSalesItem = (type?: ItemType | String) =>
  type === ItemType.Sales || type === ItemType.Service;
